import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import ElementContainer from './ElementContainer';

const styles = {
    fontSize: '24px',
};

export default function DialogTitle(props) {
    return (
        <ElementContainer>
            <span style={{ ...styles }}>
                {props.children}
            </span>
        </ElementContainer>
    );
}

DialogTitle.displayName = displayName('Dialog/Title');

DialogTitle.propTypes = {
    children: PropTypes.any.isRequired,
};
